qtee.customDesign = window.qtee.customDesign || {};

/** Header Item */
qtee.customDesign.HeaderView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/header'
});
